import React , { useState } from "react";
import { Button } from "../components/ui/button";
import { Card, CardContent } from "../components/ui/card";
import "../singapore.css";

const packages = [
  {
    id: 1,
    title: "3 Night 4 Days Singapore Experience",
    description: "Wildlife • City Tour • Sentosa • Universal Studios",
    duration: "3 Nights 4 Days",
    highlights1: 
    " Day 1: Arrival &  Wildlife Experience" ,
    
    highlights2: 
    "Day 2: City Tour &  Sentosa Fun" ,
    
    highlights3: 
    "Day 3: Thrills at Universal Studios" ,
    
    highlights4: 
    "Day 4: Departure", 

    Dayplan1: [
    "Private airport-to-hotel transfer",
    "Visit one of Singapore’s world-famous wildlife parks:<br/>Singapore Zoo, Night Safari, Bird Paradise, or River Safari with Boat Ride"
    
    ],

    Dayplan2: [
    " Guided Singapore City Tour",
    "Afternoon at Sentosa Island<br/>One-way cable car ride<br/>Wings of Time light & sound show"
   
  ],

    Dayplan3: [
    "Full-day access to Universal Studios Singapore"
  ],

    Dayplan4:[
    "Private hotel-to-airport transfer"
    ],
    hotels: [
      { category: "Hotel Category", name: "Hotels", price: "Price (Per Person)" },
      { category: "3-Star", name: "Hotel Boss / Chancellor", price: "SGD 720" },
      { category: "4-Star", name: "Novotel Singapore on Kitchener", price: "SGD 925" },
      { category: "5-Star", name: "Orchard Hotel / One Farrer Hotel", price: "SGD 1110" }
    ],

    stayoption:"Stay Options (3 Nights with Daily Breakfast):" ,
    infobox:"Book this land package along with your cruise for a seamless, all-in-one vacation experience." ,

    packageinclude:[
      "3 Nights hotel stay with breakfast",
      "All transfers in private vehicle",
      "Entry tickets to listed attractions",
      "Customisation available based on your cruise dates"
    ],

    imageUrl: "https://images.unsplash.com/photo-1565967511849-76a60a516170?q=80&w=2071&auto=format&fit=crop"
  },

  {
    id: 2,
    title: "4 Night 5 Days Complete Singapore",
    description: "Wildlife • City Tour • Sentosa • Universal Studios • Gardens by the Bay",
    duration: "4 Nights 5 Days",
    highlights1: 
    " Day 1: Arrival & Wildlife Visit" ,
    
    highlights2: 
    "Day 2: City Sights & Sentosa Adventure" ,
    
    highlights3: 
    "Day 3: Fun at Universal Studios" ,
    
    highlights4: 
    "Day 4: Gardens by the Bay &amp; Leisure", 
 
    highlights5: 
    "Day 5: Departure", 

    Dayplan1: [
    "Arrival in Singapore",
    "Private transfer from airport to hotel",
    "Visit one of Singapore’s signature wildlife parks:<br/> Singapore Zoo, Night Safari, Bird Paradise, or River Safari with Boat Ride"
    ],

    Dayplan2: [
    "Half-day Singapore City Tour",
    "Lunch in the city",
    "Afternoon at Sentosa Island:<br/>Cable Car Ride<br/>4D AdventureLand (any 2 rides)<br/>Wings of Time show"
  
  ],

    Dayplan3: [
    "Full-day visit to Universal Studios Singapore"
  ],

    Dayplan4:[
    "Entry to Gardens by the Bay (Cloud Forest + Supertree Grove)",
    "Rest of the day at leisure for shopping or personal exploration"
    ],

     Dayplan5:[
    "Private transfer from hotel to airport",
    "Departure from Singaporer"
    ],

    hotels: [
      { category: "Hotel Category", name: "Hotels", price: "Price (Per Person)" },
      { category: "3-Star", name: "Hotel Boss / Chancellor", price: "SGD 780" },
      { category: "4-Star", name: "Novotel Singapore on Kitchener", price: "SGD 985" },
      { category: "5-Star", name: "Orchard Hotel / One Farrer Hotel", price: "SGD 1170" }
    ],
    stayoption:"Stay Options (4 Nights with Daily Breakfast):" ,
    infobox:"Pair this with your cruise booking for a smooth, all-in-one travel experience from Singapore." ,

    packageinclude:[
      "4-night hotel stay with daily breakfast",
      "Private airport transfers",
      "All attraction tickets as per itinerary",
      "Inter-hotel/activity transfers",
      "Customisable based on cruise departure/arrival"
    ],

    imageUrl: "https://images.unsplash.com/photo-1565967511849-76a60a516170?q=80&w=2071&auto=format&fit=crop"
  },

  {
    id: 3,
    title: "5 Night 6 Days Ultimate Singapore",
    description: "Complete Singapore experience with Jurassic World & Marina Bay",
    duration: "5 Nights 6 Days",
    highlights1: 
    " Day 1: Arrival &  Wildlife Experience" ,
    
    highlights2: 
    "Day 2: City Tour & Sentosa Magic" ,
    
    highlights3: 
    "Day 3: Universal Studios Adventure" ,
    
    highlights4: 
    "Day 4: Gardens by the Bay & Marina Bay Magic", 

     highlights5: 
    "Day 5: Leisure Day", 

     highlights6: 
    "Day 6: Leisure Day", 

    Dayplan1: [
    "Arrival in Singapore",
    "Private airport-to-hotel transfer",
    "Visit one of Singapore’s iconic wildlife parks:<br/>Singapore Zoo, Night Safari, Bird Paradise, or River Safari with Boat Ride"
    ],

    Dayplan2: [
    " Guided Singapore City Tour",
    "Lunch in the city",
    "Afternoon at Sentosa Island:<br/>Cable Car Ride<br/>Trick Eye Museum<br/>Wings of Time Light & Sound Show"
  ],

    Dayplan3: [
    "Full-day access to Universal Studios Singapore – thrilling rides, live shows, and movie magic"
  ],

    Dayplan4:[
    "Visit Gardens by the Bay (Cloud Forest + Flower Dome)",
    "Entry to Jurassic World",
    "Explore Marina Bay Park (all tickets included)"
    ],

     Dayplan5:[
    "Free day for shopping, café-hopping, or optional experiences"
    ],

     Dayplan6:[
    "Private transfer to airport for departure"
    
    ],

    hotels: [
      { category: "Hotel Category", name: "Hotels", price: "Price (Per Person)" },
      { category: "3-Star", name: "Hotel Boss / Chancellor", price: "SGD 860"},
      { category: "4-Star", name: "Novotel Singapore on Kitchener", price: "SGD 1065" },
      { category: "5-Star", name: "Orchard Hotel / One Farrer Hotel", price: "SGD 1250"}
    ],

    infobox:"Combine this land package with your cruise for a smooth, all-in-one travel experience from Singapore!" ,
    packageinclude:[
      "5 nights hotel stay with breakfast",
      "All attraction entry tickets as per itinerary",
      "Private airport transfers",
      "Inter-activity and local transfers",
      "Customisable based on cruise departure or arrival dates"
    ],
    stayoption:"Stay Options (5 Nights with Daily Breakfast):" ,
    imageUrl: "https://images.unsplash.com/photo-1528181304800-259b08848526?q=80&w=2070&auto=format&fit=crop"
  }
];

const LandCruisePackages = () => {

  const [isOpen, setIsOpen] = useState(false);

  return (
    <section id="land-cruise" className="land-cruise-section">
      <div className="container">
        <div className="intro">
          <h2 className="heading">Land Packages</h2>
          <p className="subheading">
            From iconic landmarks to hidden gems, enhance your Singapore vacation with curated land experiences built around you.
          </p>
          <p className="note">
            Add Flights, hotel stays, transfers and Visas to book all in one booking
          </p>
        </div>

        <div className="package-grid">
          {packages.map((pkg) => (
            <Card key={pkg.id} className="package-card">
              <div className="card-image">
                <img src={pkg.imageUrl} alt={pkg.title} />
                <div className="duration-badge">{pkg.duration}</div>
              </div>
              <CardContent className="card-content">
                <h3 className="title">{pkg.title}</h3>
                {/* <p className="description">{pkg.description}</p> */}

                <div className={isOpen ? "content show" : "content"} >
                  {/* <h4 className="section-title">Package Highlights:</h4> */}
              
                    {/* {pkg.highlights.slice(0, 5).map((highlight, index) => (
                      <li key={index}>
                       {highlight}
                      </li>
                    ))} */}
                    <h5>{pkg.highlights1}</h5>
                    <ul>
                      {pkg.Dayplan1 && pkg.Dayplan1.map((item, index) => (
                       <li key={index} dangerouslySetInnerHTML={{ __html: item }} />
                       ))}
                    </ul> 
                    <h5>{pkg.highlights2}</h5>
                   <ul>
                      {pkg.Dayplan2 && pkg.Dayplan2.map((item, index) => (
                       <li key={index} dangerouslySetInnerHTML={{ __html: item }} />
                       ))}
                    </ul>  
                    <h5>{pkg.highlights3}</h5>
                   <ul>
                      {pkg.Dayplan3 && pkg.Dayplan3.map((item, index) => (
                       <li key={index} dangerouslySetInnerHTML={{ __html: item }} />
                       ))}
                    </ul> 
                    <h5>{pkg.highlights4}</h5>
                    <ul>
                      {pkg.Dayplan4 && pkg.Dayplan4.map((item, index) => (
                       <li key={index} dangerouslySetInnerHTML={{ __html: item }} />
                       ))}
                    </ul> 
                  <h5>{pkg.highlights5}</h5>
                    <ul>
                      {pkg.Dayplan5 && pkg.Dayplan5.map((item, index) => (
                       <li key={index} dangerouslySetInnerHTML={{ __html: item }} />
                       ))}
                    </ul> 
                     <h5>{pkg.highlights6}</h5>
                    <ul>
                      {pkg.Dayplan6 && pkg.Dayplan6.map((item, index) => (
                       <li key={index} dangerouslySetInnerHTML={{ __html: item }} />
                       ))}
                    </ul> 

             
                </div>

                <div className="section">
                  <h4 className="section-title">{pkg.stayoption}</h4>
                  <div className="hotel-list">
                    {pkg.hotels.map((hotel, index) => (
                      <div key={index} className="hotel-item" >
                        <span ><strong>{hotel.category}</strong></span>
                        <span> {hotel.name}</span>
                        <span className="price">{hotel.price}</span>
                      </div>
                    ))}
                  </div>
                </div>

               
                <div>
                  <h4>Package Inclusions:</h4>
                  <ul>
                    {pkg.packageinclude && pkg.packageinclude.map((item, index) => (
                       <li key={index} dangerouslySetInnerHTML={{ __html: item }} />
                       ))}
                  </ul>
                </div>

                 <div className="info-box">
                  {pkg.infobox}
                </div>

                <Button className="view-button" onClick={() => setIsOpen(!isOpen)}>View Full Itinerary</Button>
              </CardContent>
            </Card>
          ))}
        </div>

        {/* <div className="inclusion-box">
          <h3 className="section-title">All Packages Include:</h3>
          <div className="inclusion-grid">
            <div>
              <p><span className="dot" />Hotel stay with daily breakfast</p>
              <p><span className="dot" />Private airport transfers</p>
              <p><span className="dot" />All attraction entry tickets</p>
            </div>
            <div>
              <p><span className="dot" />Inter-activity transfers</p>
              <p><span className="dot" />Customizable based on cruise dates</p>
              <p><span className="dot" />24/7 support during your stay</p>
            </div>
          </div>
        </div> */}
      </div>
    </section>
  );
};

export default LandCruisePackages;
